// extracted by mini-css-extract-plugin
export default {"item_content":"MI82syMg58LYSr8isqsQ","item_icons":"KtyI_44knKgOtoXJTs6b"};